<template>
    <rkm-area
        title="Acordo de Nível de Serviço (SLA)"
        type="fieldset"
    >
        <template slot="trailing">
            <rkm-button
                :disabled="!areEqual(prioridadeModal, prioridadeOrinal)"
                :title="!areEqual(prioridadeModal, prioridadeOrinal) ? 'Salve as alterações para adicionar' : 'Adicionar'"
                @click="$refs.Modal.open()"
                color="primary"
                small
            >
                <rkm-icon icon="plus" />
            </rkm-button>
        </template>

        <List :data="data" />

        <Modal
            :data="data"
            ref="Modal"
        />
    </rkm-area>
</template>

<script>

// Components.
import List from './List'
import Modal from './Modal'

export default {
    components: { List, Modal },
    methods: {
        areEqual(a, b) {
            return JSON.stringify(a) === JSON.stringify(b)
        }
    },
    props: {
        data: { type: Object, required: true },
        prioridadeModal: { type: [Object, Array], required: true },
        prioridadeOrinal: { type: [Object, Array], required: true },
    },
}
</script>